import React from 'react'
import DrAli from "../../../../assets/drali.png"

const TherapistInfo = () => {
    return (
        <div className='max-w-5xl mx-auto md:p-6 px-3 pb-6  flex items-center flex-col justify-center space-y-4'>
            <div className='flex items-start gap-3 '>
                <div className='w-2/5 md:w-auto'>
                    <img src={DrAli} alt='Dr. Ali' className='rounded-full sm:w-32 w-full h-full sm:h-26 object-cover' />
                </div>
                <div className='space-y-2 w-4/5 md:w-auto'>
                    <p className=' rounded-md text-white px-1  bg-[#E34134] font-bold text-base w-fit'>
                        Top Pulmonologist
                    </p>
                    <h2 className='text-3xl font-bold underline text-[#132c4d]'>
                        Dr.Ali, M.D
                    </h2>
                    <div>
                        <p className='font-light  text-sm '>
                            Dr. Ali is a highly respected pulmonologist and sinus health expert. Last year, U.S. News & World Report recognized him as one of the top pulmonologists in Georgia and the Southern United States.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default TherapistInfo
